<template>
	<div class="custom-range" ref="bar">
		<div ref="thumb" class="thumb font-mediumlarge flex v-center" :style="{left : left+'%'}">
			<svg @click="decrease" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M11.5 15L6.5 10L11.5 5V15Z" fill="#151619"/></svg>
			<span class="text">{{Math.round(modelValue)}}</span>
			<svg @click="increase" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M8.5 5L13.5 10L8.5 15L8.5 5Z" fill="#151619"/></svg>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CustomRange',
		props: ['modelValue', 'min', 'max'],
		emits: ['update:modelValue', 'change'],
		data: function () { return {
			dragging : false,
		}},
		computed: {
			left(){
				return ((this.modelValue-this.min)*100)/ (this.max-this.min);
			}
		},
		mounted(){
			this.$refs.thumb.addEventListener('pointerdown', this.dragStart, {passive: true});
			window.addEventListener('pointerup', this.dragEnd);
			window.addEventListener('pointermove', this.drag);
		},
		unmounted () {
			window.removeEventListener('pointerdown', this.dragStart);
			window.removeEventListener('pointerup', this.dragEnd);
			window.removeEventListener('pointermove', this.drag);
		},
		methods: {
			increase(){
				let new_value = Math.min(this.max, this.modelValue+1);
				this.$emit('update:modelValue', new_value);
				this.$emit('change', new_value);
			},
			decrease(){
				let new_value = Math.max(this.min, this.modelValue-1);
				this.$emit('update:modelValue', new_value);
				this.$emit('change', new_value);
			},
			dragStart(){
				this.dragging = true;
			},
			dragEnd(){
				this.dragging = false;
			},
			drag(e){
				if(this.dragging && this.max > this.min){
					let bar_viewport = this.$refs.bar.getBoundingClientRect();
					let percent = (e.clientX - bar_viewport.left) /(bar_viewport.right - bar_viewport.left)
					
					let new_value = parseInt(this.min) + Math.round(percent * (this.max-this.min));
					new_value = Math.max(this.min, Math.min(this.max, new_value));
					
					
					this.$emit('update:modelValue', new_value);
					this.$emit('change', new_value);
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.custom-range{
		position: relative;
		height: 6px;
		width: 100%;
		background: white;
		
		.thumb{
			position: absolute;
			top: -11px;
			width: 60px;
			padding: 4px;
			background: white;
			color: #151619;
			border-radius: 40px;
			cursor: pointer;
			transform: translateX(-30px);
			user-select: none;
			
			svg{
				position: relative !important;
			}
		}
		
		&.blue{
			background: #BD5EFD;
			
			.thumb{
				background: #BD5EFD;
			}
		}
	}
</style>
